export enum PhoenixLocale {
	DEVICE_DEFAULT = 'none',
	EN = 'en',
	FR = 'fr',
}

export const FALLBACK_LOCALE = PhoenixLocale.EN;

export const LOCALE_STRING_NAMES = Object.values(PhoenixLocale)
	.filter((val) => val !== PhoenixLocale.DEVICE_DEFAULT)
	.map((val) => val.toString());
